(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class FrimaTrustAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-trust-item]'));
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.timer = null;

      this.handleViewportChange = this.refresh.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.handleViewportChange);
        this.reducedMotionQuery.addEventListener('change', this.handleViewportChange);
      } else {
        this.mobileQuery.addListener(this.handleViewportChange);
        this.reducedMotionQuery.addListener(this.handleViewportChange);
      }

      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.refresh();
    }

    disconnectedCallback() {
      this.stop();

      if (this.mobileQuery) {
        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.handleViewportChange);
          this.reducedMotionQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.mobileQuery.removeListener(this.handleViewportChange);
          this.reducedMotionQuery.removeListener(this.handleViewportChange);
        }
      }

      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stop();
      } else {
        this.refresh();
      }
    }

    refresh() {
      this.stop();

      const behavior = this.dataset.mobileBehavior;
      const isMobile = this.mobileQuery.matches;
      const reducedMotion = this.reducedMotionQuery.matches;

      if (!this.items.length) return;

      if (!isMobile || behavior !== 'rotator') {
        this.items.forEach((item) => {
          item.classList.add('is-active');
          item.removeAttribute('aria-hidden');
        });

        return;
      }

      this.showItem(this.activeIndex);

      if (this.items.length <= 1 || reducedMotion || document.hidden) return;

      const speed = Number(this.dataset.autoplaySpeed) || 3000;

      this.timer = window.setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.items.length;
        this.showItem(this.activeIndex);
      }, speed);
    }

    showItem(indexToShow) {
      this.items.forEach((item, index) => {
        const isActive = index === indexToShow;

        item.classList.toggle('is-active', isActive);

        if (isActive) {
          item.removeAttribute('aria-hidden');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
      });
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('frima-trust-announcement-bar')) {
    customElements.define('frima-trust-announcement-bar', FrimaTrustAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
